import CloseIcon from "icons/CloseIcon";
import styled from "styled-components";
import PlayCircleIcon from "icons/PlayCircleIcon";
import Spacer from "components/global/Spacer";
import { useContext } from "react";
import { TutorialContext } from "contexts/TutorialContext";

const Drawer = styled.div`
  display: flex;
  width: 30%;
  height: 90%;
  top: 10%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05),
    0px 25px 35px 0px rgba(0, 0, 0, 0.03);
  position: fixed;
  right: 0px;
  z-index: 10;
  overflow-y: auto;

  .header {
    width: 100%;
    height: 52px;
    padding: 12px 16px;
    border-bottom: 1px solid #f2f3f7;
    position: sticky;
    top: 0;
    background: #fff;
  }

  .videoContent {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .textContent {
    display: flex;
    flex-direction: column;
    gap: 1px;

    .headerText {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      align-self: stretch;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }

    .bodyText {
      color: #7e7e8f;
    }
  }

  .videoCard {
    display: flex;
    gap: 8px;
    padding: 0 16px;
  }

  .horizontalRule {
    border: none;
    border-top: 1px solid #e2e2ea;
  }

  @media (max-width: 768px) {
    width: 80%;
    margin: 0 auto; /* Center horizontally */
    left: 50%;
    transform: translateX(-50%);
    right: auto;
    height: 70%;
  }
`;

const modalContent = [
  {
    title: "Publishing and scheduling your content",
    description:
      "Streamline your posting and scheduling process to keep your social media active and engaging.",
    desktop_video: "https://player.vimeo.com/video/1026948352",
  },
  // {
  //   title: "Managing your post queues",
  //   description:
  //     "Organize and manage your scheduled posts to ensure a consistent social media presence.",
  //   desktop_video: "",
  // },
  // {
  //   title: "Getting post ideas",
  //   description:
  //     "Generate and manage post ideas with our AI-powered suggestions.",
  //   desktop_video: "",
  // },
  {
    title: "Getting post captions",
    description: "Craft compelling post captions using our AI tools. ",
    desktop_video: "https://player.vimeo.com/video/1026946764",
  },
  {
    title: "Managing your brand information",
    description:
      "Keep your brand information up-to-date and consistent across all platforms.",
    desktop_video: "https://player.vimeo.com/video/1026947607",
  },
  {
    title: "Working on a content calendar",
    description:
      "Plan and organize your content calendar to ensure a balanced and strategic social media approach.",
    desktop_video: "https://player.vimeo.com/video/1026949696",
  },
  {
    title: "Replying your post comments",
    description:
      "Engage with your audience by efficiently managing and responding to post comments.",
    desktop_video: "https://player.vimeo.com/video/1026948160",
  },
  {
    title: "Managing your social media channels",
    description:
      "Oversee all your social media channels from one central location.",
    desktop_video: "https://player.vimeo.com/video/1026947607",
  },
  {
    title: "How to create drafts",
    description:
      "Easily create post drafts and share with team members for comments & approval.",
    desktop_video: "https://player.vimeo.com/video/1026946048",
  },
  {
    title: "How to buy AI credits",
    description:
      "Get more credits to AI features like QuickPost, AI Caption Writer and Post Caption Generator.",
    desktop_video: "https://player.vimeo.com/video/1026946412",
  },
  {
    title: "How to manage a team on PostPaddy",
    description: "Add new members and manage their access",
    desktop_video: "https://player.vimeo.com/video/1026947774",
  },
  {
    title: "How to share a planner with a client.",
    description:
      "Share post drafts & planner with clients for comments and suggestions.",
    desktop_video: "https://player.vimeo.com/video/1026948612",
  },
  {
    title: "How to use a post planner",
    description:
      "Plan & manage your social media calendar with your team using a Planner.",
    desktop_video: "https://player.vimeo.com/video/1026950021",
  },
  {
    title: "How to manage contacts",
    description:
      "Store contact information and manage your social media contacts on PostPaddy.",
    desktop_video: "https://player.vimeo.com/video/1026950390",
  },
];

const VideoModal = ({ setShowVideo }) => {
  const { handleCloseModal } = useContext(TutorialContext);

  const handleCardClick = (videoData) => {
    setShowVideo(videoData);
    handleCloseModal();
  };

  return (
    <Drawer>
      <div className="header flexRow alignCenter justifySpaceBetween">
        <div className="l1-normal semiBold">Quick Tutorials</div>
        <CloseIcon onClick={handleCloseModal} className="cursorPointer" />
      </div>

      <div className="videoContent">
        {modalContent.map((content, index) => (
          <div key={index} onClick={() => handleCardClick(content)}>
            <div className="videoCard cursorPointer">
              <div>
                <PlayCircleIcon />
              </div>
              <div className="textContent">
                <p className="headerText">{content.title}</p>
                <p className="bodyText l3 ">{content.description}</p>
              </div>
            </div>
            <Spacer y={1} />
            <div className="horizontalRule" />
          </div>
        ))}
      </div>
    </Drawer>
  );
};

export default VideoModal;
